import Model from './Model'

export default class DeliveryContact extends Model {
    static async all() {
        const {data} = await Http.get(route('api.v1.packages-delivery-contacts.index'))
        return this.make(data)
    }
}
